import React from 'react';
import { Auth } from '@leverege/api-redux';
import { Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.screens.main.LogOut');
function LogOut({
  context
}) {
  const {
    clientProps: {
      dispatch
    }
  } = context;
  const onClick = () => {
    dispatch(Auth.logout());
  };
  return /*#__PURE__*/React.createElement(Button, {
    variant: 'secondary',
    name: t('name'),
    onClick
  }, [t('name')]);
}
export default {
  id: 'user.mobile.LogOut',
  matches: {
    use: 'footerBar',
    client: 'Main'
  },
  layout: {
    sort: 'zzzz'
  },
  handles: context => {
    return Auth.getProfile(GlobalState.get().auth) != null && context?.mobile;
  },
  customComponent: LogOut
};